import { render, staticRenderFns } from "./CreateTestModal.vue?vue&type=template&id=33de275e&scoped=true&"
import script from "./CreateTestModal.vue?vue&type=script&lang=js&"
export * from "./CreateTestModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTestModal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CreateTestModal.vue?vue&type=style&index=1&id=33de275e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de275e",
  null
  
)

export default component.exports